const swiperReason = new Swiper('.reason-slider__contents', {
  loop: true,
  slidesPerView: 1.45,
  spaceBetween: 18,
  pagination: {
    el: '.reason-pagination',
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
    },
    980: {
      slidesPerView: 4,
      spaceBetween: 18.5,
    },
  }
});